/* eslint import/no-named-as-default: 0 */
/* eslint import/no-named-as-default-member: 0 */
import $ from 'jquery';
import 'jquery-visible';
import LazyLoad from 'vanilla-lazyload';
// eslint-disable-next-line import/no-extraneous-dependencies, import/extensions
import videojs from 'video.js/dist/alt/video.novtt.js';

import cAppeared from '../components/c-appeared';
import preloader from '../components/c-preloader';
import bookingPreloader from '../components/booking-preloader';
import cookieConsentDelay from '../components/c-cookie-consent-delay';
import cOutline from '../components/c-outline';
import cSkipMain from '../components/c-skip-main';
import iosBottomAnchor from '../components/c-ios-bottom-anchor';
import { initVideoControls } from '../components/video-controls';
import { getBreakpoints } from '../utils/utils';

window.videojs = videojs;

cookieConsentDelay();
cAppeared();
cOutline();
bookingPreloader();
preloader();
cSkipMain();
iosBottomAnchor();

/**
 * Common JS functions
 */

/**
 * //TODO refactoring in case of adding another language
 * @return {{xl: number, md: number, sm: number, xs: number, lg: number, xxl: number}}
 */

window.gridBreakPoints = getBreakpoints();

// eslint-disable-next-line no-unused-vars
function reloadBooking() {
  window.location.hash = '/booking/step-1';
  window.location.reload();
}

/**
 * jQuery common
 */
// eslint-disable-next-line no-shadow
(function ($) {
  function lazyImage() {
    $('.lazy-picture').each(function () {
      const $picture = $(this);
      if ($picture.visible(true) && !$picture.hasClass('lazy-picture--loaded')) {
        const $source = $picture.find('source');
        const $img = $picture.find('img');
        const dataSrc = $img.attr('data-src');
        $source.each(function () {
          const $this = $(this);
          const dataSrcset = $this.attr('data-srcset');
          $this.attr('srcset', dataSrcset);
        });
        $img.attr('src', dataSrc);
        $picture.addClass('lazy-picture--loaded');

        // if browser not support object-fit css
        if ('objectFit' in document.documentElement.style === false && $img.length && $img[0].currentStyle['object-fit']) {
          if ($picture.find('img').attr('data-ie-src').length) {
            $picture.css('backgroundImage', `url(${$picture.find('img').attr('data-ie-src')})`).addClass('c-thumbnail__compat-object-fit');
          } else {
            $picture.css('backgroundImage', `url(${$picture.find('img').attr('data-src')})`).addClass('c-thumbnail__compat-object-fit');
          }
        }
      }
    });
  }
  $(window).on('load scroll', () => {
    lazyImage();
  });
  $(document).on('click tap keydown', () => {
    setTimeout(() => {
      lazyImage();
    }, 300);
  });
  lazyImage();
  // eslint-disable-next-line no-param-reassign, consistent-return
  $.fn.overflowing = function (options, callback) {
    const self = this;
    const overflowed = [];
    const hasCallback = !!(callback && typeof callback === 'function');
    let status = false;
    this.options = options || window;
    // eslint-disable-next-line consistent-return
    this.each(function () {
      if ($.isWindow(this)) return false;
      const $this = $(this);
      const elPosition = $this.position();
      const elWidth = $this.width();
      const elHeight = $this.height();
      const parents = $this.parentsUntil(self.options);
      const $parentsTo = $(self.options);
      parents.push($parentsTo);
      for (let i = 0; i < parents.length; i++) {
        const $parent = $(parents[i]);
        if ($.isWindow($parent[0])) break;
        // eslint-disable-next-line no-bitwise
        const absPosition = !!~['absolute', 'fixed'].indexOf($parent.css('position'));
        const parentPosition = $parent.position();
        const parentWidth = $parent.width();
        const parentHeight = $parent.height();
        const parentToBottom = absPosition ? parentHeight : (parentHeight + parentPosition.top);
        const parentToRight = absPosition ? parentWidth : (parentWidth + parentPosition.left);
        if (elPosition.top < 0
          || elPosition.left < 0
          || elPosition.top > parentToBottom
          || elPosition.left > parentToRight
          || (elPosition.top + elHeight) > parentToBottom
          || (elPosition.left + elWidth) > parentToRight) {
          status = true;
          $(parents[i]).addClass('overflowed');
          overflowed.push(parents[i]);
          if (hasCallback) callback(parents[i]);
        }
      }
      if ($this.parents(self.options).hasClass('overflowed')) $this.addClass('overflowing');
    });

    if (!hasCallback) return overflowed.length > 1 ? overflowed : status;
  };
  // eslint-disable-next-line no-undef
}(jQuery));

const initPreloaderDone = () => {
  const video = document.querySelector('#heroVideo');
  const main = document.querySelector('main');
  const header = document.querySelector('header');

  // don't load hero video on mobile & tables
  if (video && $(window).width() < global.breakpoints.desktop) {
    video.classList.remove('lazy');
  }

  // eslint-disable-next-line no-new
  new LazyLoad({
    elements_selector: '.lazy',
  });

  // pagespeed hacks
  if (main) main.style.opacity = 1;
  if (header) header.style.opacity = 1;
};

// eslint-disable-next-line no-underscore-dangle
if (window.__preloaderDone) {
  initPreloaderDone();
} else {
  document.addEventListener('preloader:done', initPreloaderDone);
}

document.addEventListener('DOMContentLoaded', () => {
  const initVideoJsPlayer = (video) => {
    // If the video.js library hasn't loaded yet (external script still in
    // flight), retry shortly instead of failing once and never again.
    if (typeof window.videojs !== 'function') {
      setTimeout(() => initVideoJsPlayer(video), 500);
      return;
    }

    if (video.dataset.vjsInitialized) {
      window.videojs(video);
      return;
    }
    // eslint-disable-next-line no-param-reassign
    video.dataset.vjsInitialized = 'true';

    let srcUrl = null;
    let srcType = null;
    const source = video.querySelector('source[data-src]');
    if (source) {
      srcUrl = source.dataset.src;
      srcType = source.getAttribute('type');
      source.removeAttribute('data-src');
      source.setAttribute('src', srcUrl);
    }

    const mobilePoster = video.getAttribute('data-mobile-poster');
    if (mobilePoster && window.innerWidth < 768) {
      video.setAttribute('poster', mobilePoster);
      // eslint-disable-next-line no-param-reassign
      video.style.backgroundImage = `url('${mobilePoster}')`;
    }

    const videoJsPlayer = videojs(video, {
      muted: true,
      loop: true,
      html5: {
        vhs: {
          overrideNative: true,
          limitRenditionByPlayerDimensions: true,
          useDevicePixelRatio: true,
          bandwidth: 5000000,
        },
      },
    });

    if (srcUrl) {
      videoJsPlayer.src({ type: srcType, src: srcUrl });
    }
    videoJsPlayer.ready(() => {
      videoJsPlayer.play();

      if (video.classList.contains('hasPlayPause') && video.tagName === 'VIDEO-JS') {
        const videoElem = videoJsPlayer.el().querySelector('video');

        if (videoElem) {
          initVideoControls([videoElem], 100 + Math.floor(Math.random() * 200));
        }
      }
    });
  };

  const lazyLoadVideoJs = (video) => {
    const initOnInteraction = () => {
      initVideoJsPlayer(video);
      window.removeEventListener('scroll', initOnInteraction);
      window.removeEventListener('touchstart', initOnInteraction);
      window.removeEventListener('mousemove', initOnInteraction);
    };

    window.addEventListener('scroll', initOnInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', initOnInteraction, { once: true, passive: true });
    window.addEventListener('mousemove', initOnInteraction, { once: true, passive: true });
  };

  window.initLazyVideoJsPlayer = initVideoJsPlayer;

  document.querySelectorAll('video-js.autoDetect').forEach((video) => {
    lazyLoadVideoJs(video);
  });

  document.querySelectorAll('video-js.enabledPoster').forEach((video) => {
    const initPosterVideo = () => {
      if (!video.dataset.vjsInitializedPoster) {
        // eslint-disable-next-line no-param-reassign
        video.dataset.vjsInitializedPoster = 'true';
        videojs(video);
      }
    };

    let timeoutId;
    const initOnInteraction = () => {
      clearTimeout(timeoutId);
      initPosterVideo();
      window.removeEventListener('scroll', initOnInteraction);
      window.removeEventListener('touchstart', initOnInteraction);
    };

    const scheduleTimeout = () => {
      timeoutId = setTimeout(initOnInteraction, 2000);
    };

    if (document.readyState === 'complete') {
      scheduleTimeout();
    } else {
      window.addEventListener('load', scheduleTimeout, { once: true });
    }

    window.addEventListener('scroll', initOnInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', initOnInteraction, { once: true, passive: true });
  });
});
export default true;

document.addEventListener('DOMContentLoaded', () => {
  const nativeVideos = document.querySelectorAll('video[data-mobile-poster]');
  nativeVideos.forEach((video) => {
    const mobilePoster = video.getAttribute('data-mobile-poster');
    if (mobilePoster && window.innerWidth < 768) {
      video.setAttribute('poster', mobilePoster);
    }
  });
});
